<div class="time-picker-wrapper" (click)="open()">
  <ion-item class="time-picker-item" lines="none">
    <div class="result-value">{{ value || '0:00:00' }}</div>
  </ion-item>
  
  <div class="label-text">{{ label }}</div>
</div>
